import { createSlice, Dispatch } from "@reduxjs/toolkit";
import { IRootState } from "../../../../models/interface";
import { ICategoryState } from "../../../../models/interface/ICategoryState";
import { categories } from "../../../../services";
import i18n from "../../../../i18n";
const initialState: ICategoryState = {};

export const categorySlice = createSlice({
  name: "category",
  initialState: initialState,
  reducers: {
    setCategories: (state, action) => {
      state.categories = action.payload;
    },
    setMenuCategories: (state, action) => {
      state.menuCategories = action.payload;
    },
    setBannersCategory: (state, action) => {
      if (action.payload.category_children_id) {
        if (action.payload.category_children_id?.is_parent_lv2) {
          if (action.payload.category_children_id_lv2 && action.payload.slug) {
            state.bannersCategory = {
              ...state.bannersCategory,
              [`${action.payload.category_children_id.slug}?${i18n.t(
                "detail_query"
              )}=${action.payload.slug}`]: action.payload,
            };
            // state.bannersCategory = {
            //   ...state.bannersCategory,
            //   [`${action.payload.category_children_id.slug}?id=${action.payload.category_children_id_lv2.category_ids[0]}`]:
            //     action.payload,
            // };
          } else {
            state.bannersCategory = {
              ...state.bannersCategory,
              [action.payload.category_children_id.slug]: action.payload,
            };
          }
        } else {
          if (action.payload.slug) {
            state.bannersCategory = {
              ...state.bannersCategory,
              [`${action.payload.category_parent_id.slug}?${i18n.t(
                "detail_query"
              )}=${action.payload.slug}`]: action.payload,
            };
          } else {
            state.bannersCategory = {
              ...state.bannersCategory,
              [action.payload.category_parent_id.slug]: action.payload,
            };
          }

          // state.bannersCategory = {
          //   ...state.bannersCategory,
          //   [`${action.payload.category_parent_id.slug}?id=${action.payload.category_children_id.category_ids[0]}`]:
          //     action.payload,
          // };
        }
      } else {
        state.bannersCategory = {
          ...state.bannersCategory,
          [action.payload.category_parent_id.slug]: action.payload,
        };
      }
    },
  },
});

export const { setCategories, setMenuCategories, setBannersCategory } =
  categorySlice.actions;

export const getCategories = (query: {}) => (dispatch: Dispatch) => {
  categories.getCategories(query, (data, err) => {
    if (data && data.length != 0) {
      dispatch(setCategories(data));
    }
  });
};

export const getMenuCategories = (info: any) => (dispatch: Dispatch) => {
  categories.getMenuCategories(info, (data, err) => {
    if (data && data.docs && data.docs.length) {
      dispatch(setMenuCategories(data.docs));
    }
  });
};

export const getBannersCategory = (info: any) => (dispatch: Dispatch) => {
  categories.getBannersCategory(info, (data, err) => {
    if (data) {
      dispatch(setBannersCategory(data));
    }
  });
};

export const selectCategories = (state: IRootState) =>
  state.category.categories;

export const selectMenuCategories = (state: IRootState) =>
  state.category.menuCategories;

export const selectBannersCategory = (state: IRootState) =>
  state.category.bannersCategory;

export default categorySlice.reducer;
